/**
 * @overview: desc
 * @version r24898 | jesposito | 2018-07-23 01:36:01
 */

import autobind from "autobind-decorator";
import { IQueryOne, QueryOne } from "core/api/query";
import { IPanelProps, Panel } from "core/decorators/Panel";
import React from "react";
import styled from "styled-components";
import MetabaseEmbed from "./entities/MetabaseEmbed";
import MetabasePanelConfig from "./MetabasePanelConfig";

@Panel({id: "metabase", configClass: MetabasePanelConfig, pageParams: true})
@QueryOne(MetabaseEmbed, {type: "QUESTION"}, true)
class MetabasePanel extends React.PureComponent<IPanelProps<MetabasePanelConfig> & IQueryOne<MetabaseEmbed>> {

	@autobind
	public getQueryParams() {
		return {
			id: this.props.config.resourceId,
			params: [
				{key: "guid", value: this.props.pageParams.guid} // TODO make separate org stats panel
			]
		};
	}

	public render() {
		return <Frame src={this.props.entity.url} />;
	}
}

const Frame = styled.iframe`
	border: 0;
	height: 600px;
	width: 100%;
	border-radius: inherit;
`;



// WEBPACK FOOTER //
// ./src/panels/metabase/Metabase.panel.tsx